import { render, staticRenderFns } from "./Dropdown4.vue?vue&type=template&id=5c09952f"
import script from "./Dropdown4.vue?vue&type=script&lang=js"
export * from "./Dropdown4.vue?vue&type=script&lang=js"
import style0 from "./Dropdown4.vue?vue&type=style&index=0&id=5c09952f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports